import { api } from "./api"

export const GET_ALL_VEHICLES = async (params = {}) => {
    const {data} = await api.get(`/vehicles/all`, { params })
    return data;
}

export const GET_VEHICLE_DETAILS = async (id, date = undefined) => {
    const {data} = await api.get(`/vehicles/${id}/details`, { params: { date } })
    return data;
}

export const GET_VEHICLE_TRAJECT = async (id, params) => {
    const {data} = await api.get(`/vehicles/${id}/traject`, {params})
    return data;
}

export const DELETE_VEHICLE = async (vehicleId) => {
    const {data} = await api.delete(`/vehicles/${vehicleId}`)
    return data;
}

export const SAVE_VEHICLE = async (params) => {
    const {data} = await api.post(`/vehicles/save`, params)
    return data;
}

export const SAVE_VEHICLE_DEVICE = async (vehicleId, deviceId) => {
    const {data} = await api.patch(`/vehicles/${vehicleId}/set-device/${deviceId}`)
    return data;
}
